module.exports = __webpack_public_path__ + "img/app_logo_main_white_001.f9625b1a.png";